import { render, staticRenderFns } from "./TabsDashboardCharterUploads.vue?vue&type=template&id=4db5c90c&"
import script from "./TabsDashboardCharterUploads.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardCharterUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports